(function () {
  'use strict';

  angular
    .module('app.account-order-tracking', [])

    .component('accountOrderTracking', {
      bindings: {
        result: '<',
        device: '<'
      },
      /* @ngInject */
      templateUrl: ["AccountService", function (AccountService) {
        return AccountService.getLinks().AccountOrderTracking;
      }],
      /* @ngInject */
      controller: ["$scope", "$timeout", "$location", "AppService", "AccountService", "DateService", function ($scope, $timeout, $location, AppService, AccountService, DateService) {
        var ctrl = this;

        AccountService.initAccount(ctrl);

        ctrl.$onInit = function () {

          $scope.device = ctrl.device;

          ctrl.loading = true;

          AppService.getParams()
            .then(function (params) {
              if (!params.Account.IsManagementOrderTracking) {
                $location.path(ctrl.links.AccountHome);
              } else {
                ctrl.showTTCPrice = params.Visitor.CardType.ShowTTCPrice;
                AccountService.getOrders()
                  .then(function (response) {
                    _.each(response.Orders, function (order) {
                      var date = DateService.stringToDate(order.CreationDate);
                      order.timestamp = date.getTime();
                      order.isOpen = false;
                      $timeout(function () {
                        order.init = true;
                      }, 350);
                    });
                    ctrl.orders = _.filter(response.Orders, function (order) {
                        return order.IDState !== 390 // 390 for settled order
                            && order.IDState !== 430 // 430 for settled order partially sended
                            && order.IDState !== 630 // 630 for settled order totally sended
                            && order.IDState !== 610 // 610 for for settled order totally sended
                            && order.IDState !== 410 // 410 for temp order
                            && order.IDState !== 2410 // 2410 for temp order
                            && order.IDState !== 490; // 490 for invoice
                        // TODO : Find a way to only select useful IDState instead of eliminate useless ones.
                    });
                    ctrl.orderHistory = _.filter(response.Orders, function (order) {
                        return order.IDState === 390;
                    });
                    ctrl.count = ctrl.orders.length;
                    $timeout(function () {
                      if (ctrl.count) {
                        ctrl.orders[0].isOpen = true;
                      }
                    }, 1000);

                    ctrl.loading = false;
                  })
                  .catch(function (error) {
                    console.error(error);
                  });
              }
            })
            .catch(function (error) {
              console.error(error);
            });

        };

        ctrl.getOrder = function (order) {
          if (order.loaded) return;
          getOrder(order);
        };

        ctrl.setFilterOptions = function (options) {
          ctrl.filterOptions = options;
          ctrl.setFilterHistory(ctrl.filterOptions[1]);
          if (!ctrl.orderHistoryFiltered.length) {
            ctrl.setFilterHistory(ctrl.filterOptions[2]);
            if (!ctrl.orderHistoryFiltered.length) {
              ctrl.setFilterHistory(ctrl.filterOptions[ctrl.filterOptions.length - 1]);
            }
          }
        };

        ctrl.setFilterHistory = function (option) {
          ctrl.filterSelected = option;
          if (option.months === -1) {
            ctrl.orderHistoryFiltered = ctrl.orderHistory;
            return;
          }
          var limit = new Date();
          limit.setMonth(limit.getMonth() - option.months);
          limit = limit.getTime();

          ctrl.orderHistoryFiltered = _.filter(ctrl.orderHistory, function (order) {
            return order.timestamp > limit;
          });
        };

        // Functions

        function getOrder(order) {
          AccountService.getOrder(order.IDFolder)
            .then(function (data) {
              order.loaded = true;
              angular.extend(order, data.Order);
              order.pendingLines = [];
              order.canceledLines = [];
              _.each(order.Products, function (line) {
                if (line.State === 2) {
                  order.pendingLines.push(line);
                }
                if (line.State === 3) {
                  order.canceledLines.push(line);
                }
                getCustom(line);
              });
              var tradeActions = [];
              var actionsCo = [];
              _.each(order.TradeActions, function (tradeAction) {
                if (tradeAction.TradeActionKey === 'PortOffert') {
                  if (order.Shipping.Key !== 'ENLEVEMENT') order.Shipping.free = true;
                } else if (tradeAction.TradeActionKey === 'BonReduction') {
                  actionsCo.push(tradeAction);
                } else {
                  tradeActions.push(tradeAction);
                }
              });
              order.TradeActions = tradeActions;
              order.ActionsCo = actionsCo;
              _.each(order.FoldersShipping, function (folderShipping) {
                _.each(folderShipping.TradeActions, function (tradeAction) {
                  if (tradeAction.TradeActionKey === 'PortOffert') {
                    if (order.Shipping.Key !== 'ENLEVEMENT') order.Shipping.free = true;
                    return false;
                  }
                });
              });
            })
            .catch(function (error) {
              console.error(error);
            });
        }

        function getCustom(line) {
          if (line.Product.Customization) {
            _.each(line.Product.Customization.Items, function (item) {
              if (!item.Group) {
                if (item.Field.Code === 'DateEnvoi') {
                  item.Field.Value = item.Field.Value.split('T')[0];
                }
              }
              if (item.Group) {
                _.each(item.Group.Fields, function (field) {
                  if (field.Code === 'DateEnvoi') {
                    field.Value = field.Value.split('T')[0];
                  }
                });
              }
            });
          }
        }
      }],
      controllerAs: 'accountCtrl'
    });

})();
